// extracted by mini-css-extract-plugin
export default {"header":"tile-header_header__x7Tl4","title_container":"tile-header_title_container__ue1RM","link":"tile-header_link__GvAFI","title":"tile-header_title__gJvnT"};